export default "__VITE_ASSET__UOlbmxrR__"